if (!customElements.get('product-tabs-section')) {
  class ProductTabsSection extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.product-tabs__tab'));
      this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));
      this.shopAllLinks = Array.from(this.querySelectorAll('[data-shop-all]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(Number(tab.dataset.index)));
      });

      if (window.Shopify?.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const index = event.target?.dataset?.index;
          if (index != null) this.activate(Number(index));
        });
      }
    }

    activate(index) {
      if (Number.isNaN(index)) return;

      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.index) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      let activeTab = null;
      this.panels.forEach((panel) => {
        const isActive = Number(panel.dataset.index) === index;
        panel.toggleAttribute('hidden', !isActive);
        panel.classList.toggle('is-active', isActive);

        if (isActive) {
          activeTab = this.tabs.find((tab) => Number(tab.dataset.index) === index);

          const template = panel.querySelector('template[data-product-tabs-template]');
          if (template) template.replaceWith(template.content);

          const carousel = panel.querySelector('swiper-component');
          if (carousel?.swiper) {
            carousel.swiper.update();
          } else {
            carousel?.initNow?.();
          }
        }
      });

      // Point the "Shop all" / "View all" links at the active tab's collection.
      const collectionUrl = activeTab?.dataset?.collectionUrl;
      if (collectionUrl) {
        this.shopAllLinks.forEach((link) => {
          link.setAttribute('href', collectionUrl);
        });
      }
    }
  }

  customElements.define('product-tabs-section', ProductTabsSection);
}
